import { useState } from "react";
import { useAppServices } from "../../../hook/services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TermsConditionModal from "../TermsConditionModal";

const ProviderRequestModal = () => {
  const AppService = useAppServices();
  const { companyId } = useParams();
  const [open, setOpen] = useState(false);
  const [providerName, setProviderName] = useState("");
  const [description, setDescription] = useState("");
  const [loomVideo, setLoomVideo] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    if (!accepted) {
      toast.error(
        "⚠️ You must accept the terms and condition before submitting."
      );
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        companyId,
        providerName,
        description,
        loomVideo,
        termsAndCondition: accepted,
      };

      console.log("Submitting Provider Request:", payload);
      const { response } = await AppService.provider_requests.create({
        payload,
      });
      toast.success("Provider Request Submitted Successfully");
      handleClose();
      setProviderName("");
      setDescription("");
      setLoomVideo("");
      setAccepted(false);
    } catch (error) {
      console.error("Error submitting provider request:", error);
      toast.error("Something Went Wrong While Submitting Provider Request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-primary d-flex align-items-center gap-2"
        onClick={handleOpen}
      >
        New App Request
      </button>

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              {/* Header */}
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold text-dark">App Request</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                  disabled={submitting}
                ></button>
              </div>

              {/* Body */}
              <div className="modal-body pt-2">
                <div className="mb-3">
                  <label className="form-label fw-semibold text-dark">
                    App Name
                  </label>
                  <input
                    type="text"
                    className="form-control border-2 rounded-3"
                    placeholder="Enter App name"
                    value={providerName}
                    onChange={(e) => setProviderName(e.target.value)}
                    disabled={submitting}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold text-dark">
                    Description
                  </label>
                  <textarea
                    className="form-control border-2 rounded-3"
                    rows={3}
                    placeholder="Enter description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={submitting}
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold text-dark">
                    Loom Video URL
                  </label>
                  <input
                    type="url"
                    className="form-control border-2 rounded-3"
                    placeholder="https://www.loom.com/share/..."
                    value={loomVideo}
                    onChange={(e) => setLoomVideo(e.target.value)}
                    disabled={submitting}
                  />
                </div>

                {/* Privacy Policy Checkbox */}
                <div className="form-check mt-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="acceptPolicy"
                    checked={accepted}
                    onChange={(e) => setAccepted(e.target.checked)}
                    disabled={submitting}
                  />
                  <div className="text-muted">
                    I accept the <TermsConditionModal />
                  </div>
                </div>
                <p className="small text-muted mt-2">
                  By submitting this request, you agree to our terms and
                  conditions regarding data usage and integration permissions.
                </p>
              </div>

              {/* Footer */}
              <div className="modal-footer border-top-0 pt-0">
                <button
                  type="button"
                  className="btn btn-primary px-4 py-2 rounded-3 shadow-sm"
                  onClick={handleSubmit}
                  disabled={
                    submitting || !providerName || !description || !accepted
                  }
                >
                  {submitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle me-2"></i>
                      Submit Request
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProviderRequestModal;
